import styled, { css } from 'styled-components';

import mixin from '../../../_foundations/Mixin';

export const JobLocationContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto 1fr;
  row-gap: 0;
  height: 100%;
`;
export const JobLocationHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  row-gap: 0.25rem;
  column-gap: 0.75rem;
  padding: 0.75rem;
`;
export const JobLocationCount = styled.div`
  ${mixin.text({ size: 400, strong: true })}
`;
export const JobLocationAddress = styled.div`
  ${mixin.text({ size: 100 })}
`;
export const JobLocationClear = styled.i`
  display: inline-grid !important;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  cursor: pointer;
  & > svg {
    fill: currentColor;
    stroke: currentColor;
    shape-rendering: geometricPrecision;
    height: 1em;
  }
  & > svg path {
    shape-rendering: geometricPrecision;
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
      & > svg {
        height: ${size}px;
      }
    `}
  ${({ color }) =>
    color &&
    css`
      color: var(--${color});
    `}
`;

export const JobLocationResults = styled.div`
  overflow: auto;
  ${mixin.border()}
  border-width: 1px 0 0;
  .pagination {
    margin: 0.75rem 0;
  }
  .pagination .page-item .page-link {
    padding: 0.25rem;
    min-width: 2rem;
  }
  ${(props) =>
    props.primaryColor &&
    css`
      .pagination .page-item.active .page-link {
        background: ${props.primaryColor};
      }
    `}
`;
